import React from "react";
import { Link } from "react-router-dom";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Mail } from "react-feather";
import { Phone } from "react-feather";
import { Translate } from "react-localize-redux";

import siprc from "../../images/Affiliates/siprc.png";
import nfl from "../../images/Affiliates/nfl.png";
import worldRugby from "../../images/Affiliates/world_rugby.png";
import shred from "../../images/ShredLogos/secondary_shred.png";
import heronLab from "../../images/Affiliates/heron-lab.jpg";
import "./Footer.css";

export const Footer = () => {
  const settings = {
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 10000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <footer className="footer">
      <div className="footer-secondary">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12" style={{ cursor: "grab" }}>
              <Slider {...settings}>
                <div>
                  <img
                    className="item affiliates"
                    alt="siprc logo"
                    src={siprc}
                    height={100}
                    width="auto"
                    style={{ margin: "auto" }}
                  />
                </div>
                <div>
                  <img
                    className="item affiliates"
                    alt="nfl logo"
                    src={nfl}
                    height={100}
                    width="auto"
                    style={{ margin: "auto" }}
                  />
                </div>
                <div>
                  <img
                    className="item affiliates"
                    alt="world rugby logo"
                    src={worldRugby}
                    height={100}
                    width="auto"
                    style={{ margin: "auto" }}
                  />
                </div>
                <div>
                  <img
                    className="item affiliates"
                    alt="heron lab logo"
                    src={heronLab}
                    height={100}
                    width="auto"
                    style={{ margin: "auto" }}
                  />
                </div>
                <div>
                  <img
                    className="item affiliates"
                    alt="shred logo"
                    src={shred}
                    height={100}
                    width="auto"
                    style={{ margin: "auto" }}
                  />
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-primary footer-background-color">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-3 footer-widget">
              <h5 className="heading text-white">
                <Translate id="footer.quickLinksHeader1" />
                <span className="text-primary">
                  <Translate id="footer.quickLinksHeader2" />
                </span>
              </h5>
              <ul className="quick-links">
                <li>
                  <Link to="/about" className="btn-custom-muted">
                    <Translate id="footer.about" />
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us" className="btn-custom-muted">
                    <Translate id="footer.contactUs" />
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 footer-widget">
              <h5 className="heading text-white">
                <Translate id="footer.contactUsHeader1" />
                <span className="text-primary">
                  <Translate id="footer.contactUsHeader2" />
                </span>
              </h5>
              <address>
                <p className="text-primary">
                  <Translate id="footer.studyName" />
                </p>
                <span>
                  KNB3300
                  <br />
                  <Translate id="footer.faculty" />,
                  <br />
                  <Translate id="footer.institution" />
                </span>
                <br />
                <br />
                <span>
                  2500 University Dr. NW
                  <br />
                  Calgary, AB
                  <br />
                  T2N 1N4
                </span>
              </address>
              <div
                style={{ display: "flex", alignItems: "center" }}
                className="text-primary"
              >
                <Mail size={16} className="mr-2" />
                SHRedConcussions@ucalgary.ca
              </div>
              <div
                style={{ display: "flex", alignItems: "center" }}
                className="text-primary"
              >
                <Phone size={16} className="mr-2" />
                403-220-3113
              </div>
            </div>
            <span className="copyright">
              &copy; <Translate id="footer.copyright" />
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};
